module.exports = __webpack_public_path__ + "img/image35.dc7136e7.png";